export const environment = {
  production: true,
  tenant: "apogee",
  appName: "Apogee",
  api_url: "https://api.apogeenevada.com/",
  //  api_url: "http://localhost:8787/",
  admin_api_key: "apogeedminauthroutekmj",
  token_label: "__@apogee_authadmin",
};
